/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Teams_Is_ResponsibleInputs */

const en_tables_teams_is_responsible = /** @type {(inputs: Tables_Teams_Is_ResponsibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Responsible`)
};

const de_tables_teams_is_responsible = /** @type {(inputs: Tables_Teams_Is_ResponsibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is zuständig`)
};

/**
* | output |
* | --- |
* | "Is Responsible" |
*
* @param {Tables_Teams_Is_ResponsibleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_teams_is_responsible = /** @type {((inputs?: Tables_Teams_Is_ResponsibleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Teams_Is_ResponsibleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_teams_is_responsible(inputs)
	return de_tables_teams_is_responsible(inputs)
});